/*!
 - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    <one line to give the program's name and a brief idea of what it does.>
    Copyright (C) 2019  jeffy-g hirotom1107@gmail.com

    This program is free software: you can redistribute it and/or modify
    it under the terms of the GNU Affero General Public License as
    published by the Free Software Foundation, either version 3 of the
    License, or (at your option) any later version.

    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Affero General Public License for more details.

    You should have received a copy of the GNU Affero General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>.
 - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - 
*/
/// <reference types="rm-cstyle-cmts"/>
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
//                                imports.
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
import * as React from "react";

import * as monaco from "monaco-editor";
// @ts-ignore 
import DenseAppBar from "./app-bar.tsx";

// import rmc from "rm-cstyle-cmts";

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
//                            constants, types
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
type PageProps = {

};
type PageState = {
   // code: string;
   // stripedCode: string;
};

// declare const Rmc: IRemoveCStyleComments;

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
//                         module vars, functions.
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
const code = `
///  <reference types="node"/>

import React from "react";
import ReactDOM from "react-dom";

/**
 * jsdoc comment
 */
function App() {
  return (
    // TODO: can optionally include quote string in react syntax.
    // such source input does not complete successfully.
    <h1>Hello's world's</h1>
  );
}

ReactDOM.render(<App />, document.getElementById("root"));
`;

const createEditor = (dom: HTMLElement, value: string) => {
   const editor = monaco.editor.create(dom, {
      value,
      language: "typescript",
      fontFamily: "consolas",
      fontSize: 18,
      // check whitespace situation
      renderWhitespace: "boundary",
      // !!! dynamic layout
      automaticLayout: true,
      // change font size etc by mouseWheel + ctrl
      mouseWheelZoom: true,
      folding: false
   });
   const model = editor.getModel();
   if (model) {
      model.updateOptions({
         tabSize: 4,
      });
      // model.onDidChangeDecorations(e => {
      //    console.log(e);
      // });
   }

   return editor;
};

type StringMap<T> = {
   [key: string]: T
}

const styles: StringMap<React.CSSProperties> = {
    componentRoot: {
      margin: 2,
    },
    flexEditorsPane: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "stretch",
      // padding: 6px,
    },
    
    // .left-editor, .right-editor {}
    editorviewport: {
      // boxSizing: "border-box",
      border: "solid 1px rgba(192, 192, 192, 0.384)",
      borderRadius: 3,
      // overflow: "auto",
      //   fontFamily: '"Fira code", "Fira Mono", monospace',
      fontSize: 12,
      flex: "0.5 0 0",
      // width: "50%",
      height: "calc(100vh - 85px)",
      margin: "4px 2px 0 0",
      // resize: vertical,
      overflow: "auto",
    },
    paneFooter: {
      //  position: "fixed",
      //  width: "100%",
      flexGrow: 1,
      // border: "solid 1px rgba(192, 192, 192, 0.57)",
      padding: "0 8px",
      textAlign: "right",
    }
};
const readTextFromFile = (file: File) => {
   return new Promise<string>(resolve => {
       let reader = new FileReader();
       reader.onload = event => resolve((event.target as FileReader).result as string);
       reader.readAsText(file);
   });
};

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
//                       class or namespace declare.
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
const _DEBUG = 1;
const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
   // _DEBUG && console.log("onDragOver", e.nativeEvent);
   // DEVNOTE: https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer
   // none, copy, link or move.
   e.dataTransfer.dropEffect = "move"
   // DEVNOTE: If "preventDefault" is not executed, the "ondrop" event will not fire.
   e.preventDefault();
};
const createDropHandler = (onFileRead: (source: string) => void) => (e: React.DragEvent<HTMLDivElement>) => {
   _DEBUG && console.log("onDrop", e.dataTransfer.dropEffect, e.nativeEvent);
   const files = e.dataTransfer.files;
   if (files.length) {
      _DEBUG && console.log(files[0].name, e.dataTransfer.items);
      const dropType = e.dataTransfer.items[0];
      console.log(dropType.type);
      // e.dataTransfer.getData("application/json"); no
      // const img = new Image();
      // img.src = 'example.gif';
      // ev.dataTransfer.setDragImage(img, 10, 10);
      //  (/text\/(java|type)script/.test(dropType.type)/*, 0*/) &&
      readTextFromFile(files[0]).then(source => {
         onFileRead(source);
      }).catch(reason => console.warn(reason));
   }
   // need this for standard browser. (electron are not required
   e.stopPropagation();
   e.preventDefault();
};

const replaceHander: IScanEventCallback = () => false;
const jsDocPreserveHander: IScanEventCallback = ({ event, fragment/*, offset*/ }) => {
      if (event === /*ScannerEvent.MultiLineComment*/1) {
         // DEVNOTE: \b is not contained LF
         return /^\/\*(\*|!)\s/.test(fragment);
      }
      // else if (event === /*ScannerEvent.SingleLineComment*/0) {
      //    return /\/\/\/?\s*@ts-[-\w]+/.test(fragment);
      //    // return /(?:\/\/\/?\s*@ts-[-\w]+|\/\/\/\s*<reference\s)/.test(fragment);
      // }
      return false;
};

export default class Page extends React.Component<PageProps, PageState> {

   private le: monaco.editor.IStandaloneCodeEditor | undefined;
   private re: monaco.editor.IStandaloneCodeEditor | undefined;

   private handleDrop = createDropHandler(source => {
      const editor = this.le;
      if (editor) {
         editor.setValue(source);
      }
   });
   // constructor(props: PageProps) {
   //    super(props);
   //    this.state = {
   //       code,
   //       stripedCode: Rmc(code)
   //    };
   // }
   // shouldComponentUpdate(np: PageProps, ns: PageState) {
   //    // console.log(ns.stripedCode);
   //    return true;
   // }

   /**
    * @date 2020/5/17
    */
   preserveJSDoc = false;
   removeBlanks = true;
   handlePreserveJSDocOption = (value: boolean) => {
      this.preserveJSDoc = value;
      this.handleDidChangeModelContent();
   };
   handlePreserveBlanksOption = (value: boolean) => {
      this.removeBlanks = (value || void 0) as typeof this.removeBlanks;
      this.handleDidChangeModelContent();
   };

   currentPos: monaco.Position | undefined;
   handleDidChangeCursorPosition = (e: monaco.editor.ICursorPositionChangedEvent) => {
      // console.log(e.position);
      this.currentPos = e.position;
      this.forceUpdate();
   }
   handleDidChangeModelContent = (/* e: monaco.editor.IModelContentChangedEvent */) => {
      // console.log(e.changes);
      const editor = this.le;
      if (editor && this.re) {
         const code = editor.getValue();
         Rmc.reset();
         // DEVNOTE: 2020/5/17 6:37:55
         Rmc.setListener(
            this.preserveJSDoc? jsDocPreserveHander: replaceHander
         );
         const striped = Rmc(code, {
            // @ts-expect-error 
            preserveBlanks: !this.removeBlanks,
            collectRegex: true,
         });
         if (Rmc.noops !== 0) {
            const gray = "color: gray";
            const red = "color: red";
            console.warn(
               "%cprocessing was interrupted because a %csyntax error %cor a %clong line %cwas detected.",
               gray, red, gray, red, gray
            );
            const find = editor.getAction("editor.action.startFindReplaceAction");
            // const find = editor.getAction("actions.find");
            // @ts-expect-error 
            find.run().then(() => {
               console.log("startFindReplaceAction launched");
               alert(`⚠️ im sorry, scan process did not complete`);
            });
            // const model = editor.getModel()!;
            // const ranges = model.findMatches(`.{${Rmc.avoidMinified},}`, true, true, true, null, false);
            // console.log(ranges);
         }
         this.re.setValue(striped);
      }
   };

   /**
    * intialize monaco editors
    */
   componentDidMount() {
      Rmc.setListener(replaceHander);
      const left = document.getElementById("left-editor")!;
      const right = document.getElementById("right-editor")!;
      const le = createEditor(left, code);
      // @ts-expect-error 
      const re = createEditor(right, Rmc(code, { preserveBlanks: !this.removeBlanks }));
      le.onDidChangeModelContent(this.handleDidChangeModelContent);
      le.onDidChangeCursorPosition(this.handleDidChangeCursorPosition);
      this.le = le;
      this.re = re;
   }
   /**
    * dispose monaco editors
    */
   componentWillUnmount() {
      this.le!.dispose();
      this.re!.dispose();
      this.currentPos = void 0;
  }
   render() {
      const pos = this.currentPos || { lineNumber: 0, column: 0 };
      return <div style={styles.componentRoot}>
          {/* @ts -ignore  */}
         <DenseAppBar
            updateRemoveBlankLines={this.handlePreserveBlanksOption}
            updatePreserveJSDoc={this.handlePreserveJSDocOption}
         />
         <div style={styles.flexEditorsPane}>
            <div
               onDragOver={handleDragOver}
               onDrop={this.handleDrop}
               style={styles.editorviewport}
               id="left-editor"
            />
            <div style={styles.editorviewport} id="right-editor"/>
         </div>
         <div>
            <div style={styles.paneFooter}>{
               `Line: ${pos.lineNumber}, Column: ${pos.column}`
            }</div>
         </div>
      </div>;
   }
}
